import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import InsightsServices from "../../../../services/Insights.services"
import WhiteSpaceServices from "../../../../services/WhiteSpace.services";
import { setSummaryTopBrandspace, setSummaryTopWhitespace } from "../../../../store/components/Reports.slice";
import RenderComponent from "../../../General/RenderComponent"
import Container from "../../../General/Container/Container";
import WhiteSpaceSummaryTopItem from "./WhiteSpaceSummaryTopItem";
import WhiteSpaceSummaryTextDisplay from "./WhiteSpaceSummaryTextDisplay";
import { dynamicSort } from "../../../../utils/MainHelper";
import WorkerServices from "../../../../services/Worker.services";

const WhiteSpaceSummaryDisplay = React.forwardRef(({
    setDisabledDownload = () => { },
    loading,
}, ref) => {
    const dispatch = useDispatch();
    const [brandspaceText, setBrandspaceText] = useState("");
    const [whitespaceText, setWhitespaceText] = useState("");
    const [loadingWSText, setLoadingWSText] = useState(true);
    const [loadingBSText, setLoadingBSText] = useState(true);
    const [gettingTop, setGettingTop] = useState(true);
    const [selectedMicroInWS, setSelectedMicroInWS] = useState({ value: "general" })
    const [selectedMicroInBS, setSelectedMicroInBS] = useState({ value: "general" })
    const { generateGrid, whitespaceSummary: {
        topWhitespace,
        topBrandSpace
    } } = useSelector((state) => state.reports);

    const getWhitespaceSummaryText = (list) => {
        setLoadingWSText(true)
        return InsightsServices.getTopWhitespaceBrandspaceText(list).then((whitespaceRes) => {
            setLoadingWSText(false)
            if (whitespaceRes && whitespaceRes?.data?.[0]) {
                setWhitespaceText(whitespaceRes?.data?.[0])
            } else {
                setWhitespaceText("")
            }
        })
    }
    const getBrandspaceSummaryText = (list) => {
        setLoadingBSText(true)
        return InsightsServices.getTopWhitespaceBrandspaceText(list, "brandspace").then((brandspaceRes) => {
            setLoadingBSText(false)
            if (brandspaceRes && brandspaceRes?.data?.[0]) {
                setBrandspaceText(brandspaceRes?.data?.[0])
            } else {
                setBrandspaceText("")
            }
        })
    }
    useEffect(() => {
        if (generateGrid.length) {
            setGettingTop(true)
            return WorkerServices.getWhiteSpaceCache([generateGrid]).then((resp) => {
                const founds = resp[0].children.map((child) => WhiteSpaceServices.findItemInTree(child))
                WorkerServices.getWhiteSpaceCache([founds]).then(async (childrenResp) => {
                    const allChildren = childrenResp.reduce((acc, chidlItems) => {
                        acc = acc.concat(chidlItems.children)
                        return acc
                    }, [])
                    const rankedWhitespace = allChildren.sort(dynamicSort("-diff", true)).map((child, idx) => {
                        return {
                            ...child,
                            newFormulaScore: (child.diff + (idx + 1) + allChildren.length) / 3
                        }
                    })
                    const rankedBrandspace = allChildren.sort(dynamicSort("-brandSpace", true)).map((child, idx) => {
                        return {
                            ...child,
                            newFormulaScore: (child.brandSpace + (idx + 1)) * allChildren.length
                        }
                    })
                    await dispatch(setSummaryTopWhitespace(rankedWhitespace.slice(0, 10)))
                    await dispatch(setSummaryTopBrandspace(rankedBrandspace.slice(0, 10)))
                    await Promise.all([getWhitespaceSummaryText(), getBrandspaceSummaryText()])
                    await setDisabledDownload(false)
                    setGettingTop(false)
                });
            });
        }
    }, [generateGrid]);

    const onChangeWhitespaceSelect = (e) => {
        if (loadingWSText) return
        const found = topWhitespace.find((item) => item.name === e);
        if (found) {
            setSelectedMicroInWS({ ...found, value: e })
        } else {
            setSelectedMicroInWS({ value: e })
        }
        getWhitespaceSummaryText(found ? [found] : undefined)
    }

    const onChangeBrandspaceSelect = (e) => {
        if (loadingBSText) return
        const found = topBrandSpace.find((item) => item.name === e);
        if (found) {
            setSelectedMicroInBS({ ...found, value: e })
        } else {
            setSelectedMicroInBS({ value: e })
        }
        getBrandspaceSummaryText(found ? [found] : undefined)
    }
    return (
        <RenderComponent
            isFullscreen
            loadingProps={{
                loading,
                description: "Loading Charts. Please wait..."
            }}
        >
            <Container ref={ref} className="fullscreen" style={{
                width: "100%",
                height: "calc(100% - 10mm)",
                overflowY: "auto"
            }}>
                <Container className="whitespace-summarywithtext drow">
                    <WhiteSpaceSummaryTopItem
                        type="whitespace"
                        onClickItem={onChangeWhitespaceSelect}
                        title="TOP MARKETGAPS"
                        list={topWhitespace}
                        loading={gettingTop}
                    />
                    <WhiteSpaceSummaryTopItem
                        type="brandspace"
                        onClickItem={onChangeBrandspaceSelect}
                        title="TOP BRAND SPACES"
                        list={topBrandSpace}
                        loading={gettingTop}
                    />
                </Container>
                <Container className="whitespace-summarywithtext drow">
                    <WhiteSpaceSummaryTextDisplay
                        title="Market Gaps"
                        list={topWhitespace}
                        selectedMicrosegment={selectedMicroInWS}
                        text={whitespaceText}
                        onChange={onChangeWhitespaceSelect}
                        loading={loadingWSText}
                    />
                    <WhiteSpaceSummaryTextDisplay
                        title="Brand Spaces"
                        list={topBrandSpace}
                        selectedMicrosegment={selectedMicroInBS}
                        text={brandspaceText}
                        onChange={onChangeBrandspaceSelect}
                        loading={loadingBSText}
                    />
                </Container>
            </Container>
        </RenderComponent>
    );
})

export default WhiteSpaceSummaryDisplay;
